<template>
  <Modal
    :isOpen="!!component"
    :customModalClass="customModalClass"
    :title="title"
    :actionButton="actionButton"
    :centered="centered"
    @onClose="handleModalClose"
    @actionButtonClick="click"
  >
    <component
      :is="component"
      @onClose="handleClose"
      v-bind="props"
    />
  </Modal>
</template>

<script>
import { EventBus } from "../events/eventBus";
import Modal from "./common/Modal";

export default {
  components: { Modal },
  data() {
    return {
      component: null,
      title: "",
      actionButton: "",
      props: null,
      closeOnClick: true,
      customModalClass: "",
      centered: false,
    };
  },
  created() {
    EventBus.$on("open", ({
      component,
      title = "",
      actionButton = "",
      props = null,
      closeOnClick = true,
      modalContainerClass="",
      centered = false
    }) => {
      this.component = component;
      this.title = title;
      this.actionButton = actionButton;
      this.props = props;
      this.closeOnClick = closeOnClick;
      this.customModalClass = modalContainerClass;
      this.centered = centered;

      const $ = window.$;
      $("#id-modal-container").modal({
        backdrop: "static",
        keyboard: false,
      });
    });
  },
  methods: {
    handleModalClose(force=false) {
      if (!this.closeOnClick && !force)
        return;

      const $ = window.$;
      $("#id-modal-container").modal("hide");
      this.handleClose();
    },
    handleClose() {
      this.component = null;
    },
    click() {
      EventBus.$emit("actionButton-click");
    }
  },
  mounted() {
    this.$nextTick(function () {
      EventBus.$on("close-modal", () => {
        const $ = window.$;
        $("#id-modal-container").modal("hide");
        this.handleClose();
      });
    }.bind(this));
  }
};
</script>